<template>
    <div>
        <app-bar :navTab="true">
            <template #title> {{ merchantDetails.name }} </template>
            <template #status>
                <div :class="['rounded text-center mx-4 font-weight-medium text-caption py-1 px-4 status', merchantDetails.status.toLowerCase()]">
                    {{ merchantDetails.status | uppercaseFirst }}
                </div>
            </template>
            <template v-if="(merchantDetails.schedule || {}).hasScheduledSetting" #subtitle>
                <ActivationSetting />
            </template>
            <template #actionBtns>
                <v-btn class="mx-1" outlined text :to="editUrl" v-if="isPermitted(userInfo.permissions, 'merchants-update')"> <v-icon small>mdi-square-edit-outline</v-icon>Edit Merchant </v-btn>
                <v-btn color="primary" class="mx-1" :to="addBranchUrl" v-if="isPermitted(userInfo.permissions, 'merchants-branches-store')">Add Branch</v-btn>
            </template>
            <template #navigationTabs>
                <v-tabs class="tabs ml-8" :v-model="activeTab">
                    <v-tab :to="detailsUrl" v-if="isPermitted(userInfo.permissions, 'merchants-show')" exact-path>Details</v-tab>
                    <v-tab :to="$route.path" v-if="isPrimary && isPermitted(userInfo.permissions, 'merchants-branches-index')">Branches</v-tab>
                </v-tabs>
            </template>
        </app-bar>
        <v-card elevation="1" class="ma-6 ml-10">
            <DataTable module="branches" :customFilters="customFilters" v-if="isPrimary && isPermitted(userInfo.permissions, 'merchants-branches-index')" />
        </v-card>
    </div>
</template>

<script>
import AppBar from '@/components/Core/AppBar.vue';
import ActivationSetting from '@/components/Merchant/ActivationSetting.vue';
import DataTable from '@/components/Merchant/DataTable.vue';

export default {
    name: 'MerchantBranches',
    components: {
        AppBar,
        ActivationSetting,
        DataTable
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (from.name == 'view-merchant') {
                vm.fetchMerchant = false;
            }
        });
    },
    data: () => ({
        customFilters: {
            classification: { show: true, disabled: true, value: 'BRANCH' }
        },
        fetchMerchant: true
    }),
    computed: {
        //URLs
        activeTab() {
            return this.$route.path;
        },
        editUrl() {
            return this.navigation('to', ['edit', this.$route.params.id]);
        },
        addBranchUrl() {
            return this.navigation('to', ['add'], false);
        },
        detailsUrl() {
            return this.navigation('to', ['view', this.$route.params.id]);
        },
        // Merchant Details
        merchantDetails() {
            return { status: '', ...this.$store.getters['merchants/getMerchantDetails'] };
        },
        isPrimary() {
            return this.merchantDetails.classification == 'PRIMARY';
        }
    },
    mounted() {
        if (this.$route.params.id && this.fetchMerchant) {
            const config = {
                params: { appends: ['primary_merchant', 'qr_base64'] }
            };

            this.$store.dispatch('merchants/findMerchant', { id: this.$route.params.id, config: config });
        }
    }
};
</script>
